import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Button, DataGrid, Grid, IconButton, IGridColDef, Stack } from 'src/components';
import VwHbsHastaliktanimDTO from 'src/models/HastalikTanim/VwHbsHastaliktanimDTO';
import { useHastalikTanimGetirQuery, useHastalikTanimIptalMutation } from 'src/services/HastalikTanim/HastalikTanimApi';
import { translate } from 'src/i18n/tHelper';
import { useAppDispatch, useAppSelector } from 'src/store';
import HastalikTanimSlice from 'src/store/Slices/GenelTanimlar/HastalikTanimSlice';
import HastalikDialog from './HastalikDialog';
import { useConfirmation } from 'src/base/ConfirmationDialog/ConfirmationService';

interface IHastalikListProps { };
const path = 'pages|hataliktanim';
const HastalikList = (props: IHastalikListProps): JSX.Element => {
    const {data,isFetching,refetch} = useHastalikTanimGetirQuery({});
    const hastalikTanimActiveRow = useAppSelector(s => s.hastalikTanim.hastalikTanimActiveRow);
    const dialogParam = useAppSelector(s => s.hastalikTanim.dialogParam);
    const fetchParam = useAppSelector(s => s.hastalikTanim.fetchParam);

    const [iptal, iptalState] = useHastalikTanimIptalMutation();

    const dispatch = useAppDispatch();
    const confirm = useConfirmation();

    const columns: IGridColDef<VwHbsHastaliktanimDTO>[] = [
        {
            field:"adi", headerName:translate(path, 'Adı'), minWidth:100, flex:1
        },
        {
            field: 'action',
            headerName: '',
            width: 80,
            renderCell: (params) => {
              return (
                <>
                  <IconButton 
                    customType="edit" 
                    onClick={dialogParamHandler}
                  />
                  <IconButton 
                    customType="delete" 
                    onClick={() => {
                        iptalHandler(params.row);
                    }}
                    loading={iptalState.isLoading}
                  />
                </>
              );
            }
        }
    ]

    const columheaderHandler = () => {
        return(
            <Stack direction={"row"}>
                <Button 
                    customType='add'
                    onClick={dialogParamHandler}
                />
            </Stack>
        )
    }
 
    const dialogParamHandler = () => {
        hastaliktanimActiveRowHandler(new VwHbsHastaliktanimDTO());
        dispatch(HastalikTanimSlice.actions.setDialogParam(1))
    }

    const hastaliktanimActiveRowHandler = (data: VwHbsHastaliktanimDTO) => {
        dispatch(HastalikTanimSlice.actions.setHastalikTanimActiveRow(data))
    }

    const iptalHandler = (row:VwHbsHastaliktanimDTO) => {
        confirm({
            description: translate(path,"Hastalik Tanımı İptal Edilecektir. Emin Misiniz?"),
            catchOnCancel: true,
            title:"",
            variant:'danger'
        }).then(() => {
            iptal({
                id: row.id
            }).unwrap()
            .then(() => refetch());  
        })  
    }

    useEffect(() => {
        if(data?.length > 0 && !hastalikTanimActiveRow?.id)
            hastaliktanimActiveRowHandler(data[0])
        
    }, [data])

    useEffect(() => {
        if(fetchParam === 1)
        {
            refetch();
            dispatch(HastalikTanimSlice.actions.setFetchParam(0))
        }
    }, [fetchParam])

    return (
        <>
            <DataGrid
                pinnedColumns={{ right: ['action'] }}
                addHeaderColumn={columheaderHandler()}
                columns={columns}
                rows={data ? data : []}
                sx={{height:"85vh"}}
                onRowClick={(e) => hastaliktanimActiveRowHandler(e.row)}
                rowSelectionModel={[hastalikTanimActiveRow?.id]}
                enableQuickFilter
            />
            {dialogParam === 1 && <HastalikDialog />}
        </>
    );
};

export default HastalikList;